export default {"src":"/_next/static/media/stage_arrow.d7d31388.svg","height":38,"width":39,"blurWidth":0,"blurHeight":0};